import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Employee } from '../../model/employee';

@Component({
  selector: 'app-new-biddings',
  templateUrl: './new-biddings.component.html',
  styleUrls: ['./new-biddings.component.css']
})
export class NewBiddingsComponent implements OnInit {

  ImportaLicitacoes = 'https://us-central1-i-ganhei.cloudfunctions.net/ImportaLicitacoes';

  company: Company[];
  employees: Employee[];
  userCompanyUID: string;
  isCompanyAdmin: boolean;

  loading = true;

  constructor(private http: HttpClient, private dbService: DBService, private authService: AuthenticationService) { 

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
      this.isCompanyAdmin = this.authService.isCustomerAdmin();
    }

    this.loadUserData();
    
  }

  ngOnInit() {
  }

  private loadUserData() {

    this.dbService.listWithUIDs<Employee>('employees')
      .then(employees => {
        this.employees = employees;
      });

    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
          this.company = companies.filter(company => company.uid === this.userCompanyUID);
      });
    
    this.loading = false;
  }

  importBiddings() {
    if(!this.loading) {
      if(this.company[0]) {
        const data = {
          id_pesquisa: this.company[0].searchID,
          user_email: this.employees.filter(e => e.companyUID === this.company[0].uid && e.isCompanyAdmin == true)[0].email,
          user_name: this.employees.filter(e => e.companyUID === this.company[0].uid && e.isCompanyAdmin == true)[0].name,
          user_companyUID: this.company[0].uid,
          admin_sentUserUID: "zifyrF0xNmMK8QpaQ22Kp7yQPpK2",
        }
        this.http.post(this.ImportaLicitacoes, data).subscribe();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/new-biddings/new-biddings.component.ts